import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "designSystem/components/button/IconButton";
import ChipSelect from "designSystem/components/chip/ChipSelect";
import { blue } from "designSystem/styles/color";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import { Button, MenuItem } from "designSystem/index";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import BOMRevisionBreadcrumb from "./BOMRevisionBreadcrumb";
import ComparePageStore, { CompareStoreContext } from "csi/page/ComparePageStore";
import { BOM_COMPARE_REVISION } from "../Model/ApparelBom";


const PREFIX = "BOMCompareBanner";

const classes = {
	banner: `${PREFIX}banner`,
	breadcrumb: `${PREFIX}breadcrumb`,
	button: `${PREFIX}button`,
	chipSelect: `${PREFIX}chipSelect`,
	menu: `${PREFIX}menu`,
};

const StyledFlexRowCenter = styled(FlexRowCenter)((
	{
		theme,
	},
) => ({
	[`&.${classes.banner}`]: {
		backgroundColor: blue[30],
		borderBottom: `1px solid ${blue[50]}`,
		height: 38,
		justifyContent: "space-between",
		maxWidth: "100%",
	},

	[`& .${classes.breadcrumb}`]: {
		flex: 1,
		justifyContent: "center",
		maxWidth: "45%",
	},

	[`& .${classes.button}`]: {
		marginRight: theme.spacing(2),
	},

	[`& .${classes.chipSelect}`]: {
		background: blue[100],
		border: blue[300],
	},

	[`& .${classes.menu}`]: {
		flex: 1,
		justifyContent: "space-around",
		maxWidth: "calc(100% - 34px)",
	},
}));

interface BOMCompareBannerProps {
}

export const BOMCompareBanner: FunctionComponent<BOMCompareBannerProps> = observer((props) => {
	const { pageStore } = useStore();
	const comparePageStore = pageStore as ComparePageStore;

	const {
		compareWith,
		currentNodeHasOneRevision,
		endCompareMode,
		bomCompareMenuItems,
		isCompareMode,
		onChangeReadOnlyMode,
		readonlyMode,
		isCompareBomSelectEnabled,
		isCurrentBomSelectEnabled,
		showEditButton,
	} = comparePageStore;

	const {
		banner,
		breadcrumb,
		button,
		chipSelect,
		menu,
	} = classes;

	const menuItems = bomCompareMenuItems.map((resourceId) => {
		return (
			<MenuItem
				key={resourceId}
				onClick={() => compareWith(resourceId)}
				res={resourceId}
			/>
		);
	});

	return (
		<CompareStoreContext.Provider value={comparePageStore}>
			{isCompareMode && (
				<StyledFlexRowCenter className={banner}>
					<FlexRowCenter className={menu}>
						{showEditButton && (
							<Button
								design="primary"
								onClick={onChangeReadOnlyMode}
								res="Edit"
							/>
						)}
						<FlexRowCenter className={breadcrumb}>
							<BOMRevisionBreadcrumb enableAutoCompleteSelect={isCurrentBomSelectEnabled} />
						</FlexRowCenter>
						<ChipSelect
							buttonRes="BomCompareWith"
							className={chipSelect}
							disabled={readonlyMode}
						>

							<MenuItem
								disabled={currentNodeHasOneRevision}
								onClick={() => compareWith(BOM_COMPARE_REVISION)}
								res={BOM_COMPARE_REVISION}
							/>
							{menuItems}

						</ChipSelect>
						<FlexRowCenter className={breadcrumb}>
							<BOMRevisionBreadcrumb enableAutoCompleteSelect={isCompareBomSelectEnabled} isCompareMenu />
						</FlexRowCenter>
					</FlexRowCenter>
					<IconButton
						className={button}
						onClick={() => endCompareMode()}
						size="large"
					>
						<CloseIcon />
					</IconButton>
				</StyledFlexRowCenter>
			)}
		</CompareStoreContext.Provider>
	);
});

export default BOMCompareBanner;